<template>
  <div>
    <div class="order-item" v-for="(item_obj, idx) in item_arr" :key="idx">
      <div class="order-item-top">
        <div class="order-item-topleft">
          <span>单号: {{item_obj.ordersn}}</span>
        </div>
        <span>支付方式: {{item_obj.payment_code | pay_type}}</span>
      </div>
      <div class="order-item-bottom">
        <span class="order-time">{{item_obj.create_time}}</span>
        <div class="order-bot">
          <div class="order-main-left">
            <div class="main-item">
              <span>名称:</span>
              <span>{{item_obj.name}}</span>
            </div>
            <div class="main-item">
              <span>数量:</span>
              <span>{{item_obj.num}} 升</span>
            </div>
            <div class="main-item">
              <span>类型:</span>
              <span>{{item_obj.type.name}}</span>
            </div>
          </div>
          <div class="order-main-right">
            <span>￥{{item_obj.amount}}</span>
            <span>{{item_obj.pay_status == '1' ? '未支付':'已支付' }} </span>
          </div>
        </div>
      </div>
      <div v-if="canShowInvoiceButton(item_obj)" class="open-card">
        <div>发票</div>
        <span
          class="bill-primary"
          @click="handleInvoice(item_obj)"
        >发票</span>
      </div>
    </div>
  </div>
</template>
<script>
import { goWxConfigJsApi } from "@/utils/wxpay";
import wx from "weixin-js-sdk";
export default {
  props: {
    item_arr: {
      type: Array,
    },
  },
  data() {
    return {
      isMiniProgramEnv: false,
      wxConfigReady: false,
      wxCanLaunchMiniProgram: false,
    };
  },
  async mounted() {
    await this.initMiniProgramEnv();
    this.initWechatLaunchConfig();
  },
  filters: {
    pay_type(val) {
      switch (val) {
        case "balance":
          return "余额支付";
        case "allinpay":
          return "支付宝支付";
        case "unionpay":
          return "银联支付";
        case "wxpay":
          return "微信支付";
        case "cash":
          return "现金支付";
        case "card_balance":
          return "油卡支付";
        case "family_balance":
          return "亲属卡支付";
        case "team_balance":
          return "车队卡支付";
        default:
          break;
      }
    },
  },
  methods: {
    initMiniProgramEnv() {
      return new Promise((resolve) => {
        if (!window.wx || !wx.miniProgram || !wx.miniProgram.getEnv) {
          resolve(false);
          return;
        }
        wx.miniProgram.getEnv((res) => {
          this.isMiniProgramEnv = !!res.miniprogram;
          resolve(this.isMiniProgramEnv);
        });
      });
    },
    async initWechatLaunchConfig() {
      if (!this.isWechatBrowser() || this.isMiniProgramEnv) return;
      try {
        await goWxConfigJsApi("launchMiniProgram");
        wx.ready(() => {
          this.wxConfigReady = true;
          if (typeof wx.checkJsApi === "function") {
            wx.checkJsApi({
              jsApiList: ["launchMiniProgram"],
              success: (result) => {
                this.wxCanLaunchMiniProgram = !!(
                  result &&
                  result.checkResult &&
                  result.checkResult.launchMiniProgram
                );
              },
              fail: () => {
                this.wxCanLaunchMiniProgram = false;
              },
            });
          } else {
            this.wxCanLaunchMiniProgram =
              typeof wx.launchMiniProgram === "function";
          }
        });
        wx.error(() => {
          this.wxConfigReady = false;
          this.wxCanLaunchMiniProgram = false;
        });
      } catch (error) {
        console.log(error);
      }
    },
    isWechatBrowser() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    canShowInvoiceButton(item) {
      return !this.isNoInvoicePayType(item.payment_code);
    },
    handleInvoice(item) {
      if (!this.canShowInvoiceButton(item)) return;
      this.openInvoiceMiniProgram();
    },
    isNoInvoicePayType(payType) {
      return [
        "balance",
        "card_balance",
        "team_balance",
        "family_balance",
      ].includes(payType);
    },
    openInvoiceMiniProgram() {
      const miniProgramUrl = "/pages/personal/myOrder/myOrder";
      const miniProgramPath = "pages/personal/myOrder/myOrder";
      const miniProgramAppId = "wxed28bb65a2faa156";

      if (this.isMiniProgramEnv && window.wx && wx.miniProgram) {
        wx.miniProgram.switchTab({
          url: miniProgramUrl,
        });
        return;
      }

      if (
        this.isWechatBrowser() &&
        this.wxConfigReady &&
        this.wxCanLaunchMiniProgram &&
        typeof wx.launchMiniProgram === "function"
      ) {
        wx.launchMiniProgram({
          targetAppId: miniProgramAppId,
          path: miniProgramPath,
          envVersion: "release",
          success: () => {},
          fail: (err) => {
            console.log(err);
            this.$toast(
              (err && (err.errMsg || err.err_msg)) || "打开小程序失败"
            );
          },
        });
        return;
      }

      if (this.isWechatBrowser()) {
        this.$toast("当前环境不支持打开小程序");
        return;
      }

      this.$toast("请在微信内打开");
    },
  },
};
</script>
<style lang="scss" scoped>
.order-item {
  width: 96%;
  height: auto;
  margin: 10px auto;
  border-radius: 6px;
  padding: 10px 0;
  background: #ffffff;
  > .order-item-top {
    width: 100%;
    height: 30px;
    display: flex;
    padding: 4px 10px;
    align-items: center;
    border-bottom: 1px solid #dfdfdf;
    justify-content: space-between;
    > .order-item-topleft {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  > .open-card {
    width: 100%;
    padding: 10px 20px 0;
    line-height: 20px;
    text-align: right;
    font-size: 14px;
    display: flex;
    border-top: 1px solid #dfdfdf;
    justify-content: space-between;
    margin-top: 4px;
    align-items: center;
    & a:hover {
      text-decoration: none;
    }
    & span {
      display: block;
      width: 90px;
      height: 30px;
      text-align: center;
      color: #363636;
      line-height: 30px;
      border-radius: 3px;
    }
    > .bill-primary {
      color: #ec0101 !important;
      border: 1px solid #ec0101;
      background-color: #ffffff;
    }
    > .bill-disabled {
      color: #363636 !important;
      background-color: #dfdfdf;
    }
  }
  > .order-item-bottom {
    width: 100%;
    height: auto;
    padding: 0 10px;
    > .order-bot {
      width: 100%;
      height: auto;
      display: flex;
      > .order-main-left {
        width: 70%;
        display: flex;
        flex-direction: column;
        > .main-item {
          display: flex;
          font-size: 14px;
          height: 20px;
          align-items: center;
          justify-content: flex-start;
          & span:nth-child(2) {
            margin-left: 4px;
          }
        }
      }
      > .order-main-right {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 18px;
        justify-content: center;
        & span {
          width: 100%;
          display: inline-block;
          text-align: center;
        }
        & span:nth-child(2) {
          font-size: 14px;
        }

      }
    }
    > .order-time {
      font-size: 14px;
      font-weight: 560;
      color: #000000;
      line-height: 25px;
    }
  }
}
</style>
